// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__FUTZ2","disabled":"styles_disabled__SZHif","read":"styles_read__T+Nxl"};